import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppHeader from './components/layout/AppHeader';
import AppDrawer from './components/layout/AppDrawer';
import AppBody from './components/layout/AppBody';
import PublicHeader from './components/layout/PublicHeader';
import PublicBody from './components/layout/PublicBody';
import PublicFooter from './components/layout/PublicFooter';
import Login from './views/Login';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  public: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

export default function App() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route path="/widget">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/widget/:reference">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/admin">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/verify">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/verify/next">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/verify/:reference">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/scan/:reference">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/reviews/:reviewId">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/get-in-touch">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/demo">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/card-review/:type">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="/card-review">
          <div className={classes.public}>
            <PublicHeader />
            <PublicBody />
            <PublicFooter />
          </div>
        </Route>
        <Route path="*">
          <>
            <AppHeader />
            <AppDrawer />
            <AppBody />
          </>
        </Route>
      </Switch>
    </div>
  );
}
